import { injectGlobal } from '@emotion/css'

import Inter from './assets/Inter.var.woff2'

export const InterWoff2Sync = () =>
  injectGlobal(`
  @font-face {
    font-family: 'Inter';
    src: local(Inter), url(${Inter}) format("woff2");
    font-weight: 125 950;
    font-stretch: 75% 125%;
    font-style: normal;  
  }
`)
